import React, { memo } from "react";
// import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
// import { fetchContacts } from "../../redux/slices/contactsSlice";
import { RootState, AppDispatch } from "../../redux/store";
// import ChatSidebarSkeleton from "../../components/common/UI/ChatSidebarSkeleton";
import ChatSidebar from "./ChatSidebar";
import ChatRightSection from "./ChatRightSection";
import "./index.scss";

const ChatLayout = () => {
  const { currentChat } = useSelector((state: RootState) => state.chat);
  const dispatch = useDispatch<AppDispatch>();

  return (
    <div className="chat-layout-container">
      {/* {!loading ? <ChatSidebarSkeleton /> : <ChatSidebar />} */}
       <ChatSidebar />

      {currentChat ? (
        <ChatRightSection />
      ) : (
        <div className="container">
          <img
            src="/assets/images/graphic.png"
            width="30%"
            height="30%"
            className="efone-image"
            alt="Graphic"
          />
          <div className="efone-section">
            <h1>Efone Web</h1>
            <div className="efone-discription">
              <p>
                Send and receive messages without keeping your phone online.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(ChatLayout);
